import { clsx } from 'clsx'
import { useContext } from 'react'
import * as styles from './index.css'
import { SpoilerContext } from './SpoilerContext'

export interface SpoilerContentProps {
  className?: string
  children: React.ReactNode
}

export const SpoilerContent = (props: SpoilerContentProps) => {
  const context = useContext(SpoilerContext)
  if (!context) {
    throw new Error('SpoilerContent must be used within <SpoilerContainer>')
  }

  return (
    <div
      className={clsx(
        props.className,
        context.isExpanded ? styles.expanded : styles.collapsed,
      )}
    >
      {props.children}
    </div>
  )
}
